import { useEffect } from "react";
import { VALID_KEY_EVENTS, convertToAsciiEquivalent, onKeyPress } from "./keys";

const useKey = (
  callback,
  { detectKeys = [], keyevent = "keydown" }: any,
  dependencies = [],
  onMountCallback?: any
) => {
  const isKeyeventValid = VALID_KEY_EVENTS.indexOf(keyevent) > -1;

  if (!isKeyeventValid) {
    throw new Error("keyevent is not valid: " + keyevent);
  }
  if (typeof callback !== "function") {
    throw new Error("Callback needs to be a function");
  }
  if (!Array.isArray(dependencies)) {
    throw new Error("dependencies need to be an array");
  }

  let allowedKeys = detectKeys;

  if (!Array.isArray(detectKeys)) {
    allowedKeys = [];
    console.warn("Keys should be array!");
  }

  allowedKeys = convertToAsciiEquivalent(allowedKeys);

  useEffect(() => {
    const handleEvent = (event) => onKeyPress(event, callback, allowedKeys);

    window.document.addEventListener(keyevent, handleEvent);
    return () => {
      onMountCallback && onMountCallback();
      window.document.removeEventListener(keyevent, handleEvent);
    };
  }, [callback, allowedKeys, keyevent, onMountCallback]);
};
export default useKey;
